import router from "./router";
import { useTitle } from "@/hooks/web/useTitle";
import type { RouteRecordRaw } from "vue-router";
import { usePermissionStoreWithOut } from "@/store/modules/permission";
import { useCache } from "@/hooks/web/useCache";
import { NO_REDIRECT_WHITE_LIST } from "@/constants";

router.beforeEach(async (to, from, next) => {
  const { wsCache } = useCache();
  const token = wsCache.get("token");
  if (token) {
    const permissionStore = usePermissionStoreWithOut();
    if (permissionStore.getIsAddRouters) {
      next();
      return;
    }

    await permissionStore.generateRoutes("static");
    permissionStore.getAddRouters.forEach((route) => {
      router.addRoute(route as unknown as RouteRecordRaw); // 动态添加可访问路由表
    });
    const redirectPath = from.query.redirect || to.path;
    const redirect = decodeURIComponent(redirectPath as string);
    const nextData =
      to.path === redirect ? { ...to, replace: true } : { path: redirect };
    permissionStore.setIsAddRouters(true);
    next(nextData);
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next();
    } else {
      if (!wsCache.get("redirect")) {
        wsCache.set("redirect", {
          url: to.path,
          query: to.query
        })
      }
      next(`/login`); // 否则全部重定向到登录页
    }
  }
});

router.afterEach((to) => {
  useTitle(to?.meta?.title as string);
});
